export const createPayload = (data: unknown, createdAt?: number) => {
  const payload = { data, createdAt: createdAt ?? Date.now() };
  return payload;
};
